export const Initialize = 'Initialize';
export const ResetState = 'ResetState';

export const SetErrorAndWarning = 'SetErrorAndWarning';

export const SetSourceType = 'SetSourceType';

export const SetContributors = 'SetContributors';
export const UpdateContributor = 'UpdateContributor';
export const DeleteContributor = 'DeleteContributor';

export const SetTitle = 'SetTitle';
export const SetSubTitle = 'SetSubTitle';
// export const SetWebsiteTitle = 'SetWebsiteTitle';
// export const SetJournalTitle = 'SetJournalTitle';
export const SetContainerTitle = 'SetContainerTitle';
export const SetCollectionTitle = 'SetCollectionTitle';
export const SetEventTitle = 'SetEventTitle';

export const SetPublishDate = 'SetPublishDate';
export const SetAccessDate = 'SetAccessDate';
export const SetComposed = 'SetComposed';
export const SetEventDate = 'SetEventDate';

export const SetEdition = 'SetEdition';
export const SetVolume = 'SetVolume';
export const SetIssue = 'SetIssue';
// export const SetSeries = 'SetSeries';
export const SetTotalVolumes = 'SetTotalVolumes';
export const SetCitedPages = 'SetCitedPages';
export const SetSection = 'SetSection';
export const SetStatus = 'SetStatus';
export const SetNumber = 'SetNumber';
export const SetSeason = 'SetSeason';
export const SetEpisode = 'SetEpisode';
export const SetVersion = 'SetVersion';
export const SetMedium = 'SetMedium';

export const SetPublisher = 'SetPublisher';
export const SetCity = 'SetCity';
export const SetState = 'SetState';
export const SetSource = 'SetSource';
export const SetUrl = 'SetUrl';
export const SetDoi = 'SetDoi';
export const SetIsbn = 'SetIsbn';
